import ShogunStampHistoryPage from './ShogunStampHistoryPage';

export default ShogunStampHistoryPage;
